import { render, staticRenderFns } from "./InvalidWidgetWrapper.vue?vue&type=template&id=27b1bafb&"
import script from "./InvalidWidgetWrapper.vue?vue&type=script&lang=ts&"
export * from "./InvalidWidgetWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports